import { Controller, useFormContext } from 'react-hook-form'
import PropTypes from 'prop-types'
import { Box, Grid, TextField } from '@material-ui/core'

import { Card } from 'components'

const PortalDpoForm = ({ editionPermitted }) => {
  const { errors, control, watch } = useFormContext()

  const kind = watch('documentKind')

  return (
    <Card title="Preencha as informações para o Portal de Privacidade">
      <Box mb={1}>
        <Grid container spacing={1} justifyContent="flex-start">
          {kind === 'cnpj' && (
            <Grid item md={6} xs={12}>
              <Controller
                as={
                  <TextField
                    fullWidth
                    error={!!errors.responsible}
                    helperText={errors?.responsible?.message}
                    label="Nome do Responsável"
                    disabled={!editionPermitted}
                  />
                }
                control={control}
                name="responsible"
                mode="onBlur"
              />
            </Grid>
          )}
          <Grid item md={6} xs={12}>
            <Controller
              as={
                <TextField
                  fullWidth
                  error={!!errors.dpo}
                  helperText={errors?.dpo?.message}
                  label="Nome do Encarregado (DPO)"
                  disabled={!editionPermitted}
                />
              }
              control={control}
              name="dpo"
              mode="onBlur"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controller
              as={
                <TextField
                  fullWidth
                  error={!!errors.substitute}
                  helperText={errors?.substitute?.message}
                  label="Nome do Substituto"
                  disabled={!editionPermitted}
                />
              }
              control={control}
              name="substitute"
              mode="onBlur"
            />
          </Grid>
        </Grid>
      </Box>
    </Card>
  )
}

PortalDpoForm.propTypes = {
  editionPermitted: PropTypes.bool,
}

export default PortalDpoForm
